import React from 'react'
import './BidCard.css'

export default function BidCardSkeleton() {
    return (
        <>
            <div className="bid-card">
                <div className="bid-card-image bcard-skeleton-box" />
                <div className="bid-card-info">
                    <div className="bid-card-header">
                        <div className='bid-card-text-sec'>
                            <div className="sk-bid-title bcard-skeleton-box"></div>
                            <div className="sk-bid-subtitle bcard-skeleton-box"></div>
                            <div className="sk-view-link bcard-skeleton-box"></div>
                        </div>
                        <div className="sk-bid-amount bcard-skeleton-box">
                            <div className='bcard-skeleton-box'></div>
                            <div className="bid-amount bcard-skeleton-box"></div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
